/*===== Files that compile in main.min.js =======*/

window.$ = window.jQuery = require('jquery')
window.Popper = require('popper.js')
require('bootstrap')

import './index.scss'

$('.phone_btn').click(function() {
    $('input[type = tel]').focus();
});


// WEBPACK FOOTER //
// ./src/index.js